import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Products.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faEye,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";

const Product = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const productsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        "https://vimaljewellery.com/api/v1/admin/product/product-lists"
      );
      setProducts(response.data);
      setFilteredProducts(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("❌ Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `https://app.vimaljewellery.com/api/v1/admin/product/${id}`
      );
      fetchProducts();
    } catch (error) {
      console.error("❌ Error deleting product:", error);
    }
  };

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const displayedProducts = filteredProducts.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  const handleAddProduct = () => {
    navigate("/productmodel");
  };

  const handleViewAllProducts = () => {
    navigate("/products");
  };

  return (
    <div>
      <div className="actionsbuttons">
        <CSVLink data={filteredProducts} filename={"products.csv"}>
          <FontAwesomeIcon icon={faDownload} className="view-icon" />
        </CSVLink>
        <FontAwesomeIcon
          icon={faPlus}
          onClick={handleAddProduct}
          className="view-icon"
        />
        <FontAwesomeIcon
          icon={faEye}
          onClick={handleViewAllProducts}
          className="view-icon"
        />
      </div>

      <table border="1">
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Product Price</th>
            <th>Product Weight</th>
            <th>Product Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="5" style={{ textAlign: "center", padding: "40px 0" }}>
                <Spinner animation="border" variant="primary" className="mx-2" />
                <Spinner animation="grow" variant="dark" className="mx-2" />
                <Spinner animation="border" variant="success" className="mx-2" />
                <Spinner animation="grow" variant="danger" className="mx-2" />
                <Spinner animation="border" variant="danger" className="mx-2" />
                <Spinner animation="grow" variant="warning" className="mx-2" />
              </td>
            </tr>
          ) : displayedProducts.length > 0 ? (
            displayedProducts.map((product) => (
              <tr key={product.id}>
                <td>{product.productName}</td>
                <td>${product.productPrice}</td>
                <td>{product.productWeight}g</td>
                <td>
                  {product.productImage && product.productImage.imageByte ? (
                    <img
                      src={`data:${product.productImage.imageType};base64,${product.productImage.imageByte}`}
                      alt={product.productName}
                      width="50"
                      height="50"
                    />
                  ) : (
                    <img
                      src="/placeholder.png"
                      alt="placeholder"
                      width="50"
                      height="50"
                    />
                  )}
                </td>
                <td>
                  <FontAwesomeIcon
                    icon={faTrash}
                    className="view-icon"
                    onClick={() => handleDelete(product.id)}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center", padding: "40px 0" }}>
                No products found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="pagination">
        <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>
          Prev
        </button>
        <h6>
          Page {currentPage} of{" "}
          {Math.ceil(filteredProducts.length / productsPerPage)}
        </h6>
        <button
          onClick={() => setCurrentPage((prev) => prev + 1)}
          disabled={
            currentPage >= Math.ceil(filteredProducts.length / productsPerPage)
          }
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Product;
